(() => {
  const storageKey = "happyneon_wishlist_v1";
  const grid = document.querySelector("[data-hn-wishlist-grid]");
  const empty = document.querySelector("[data-hn-wishlist-empty]");
  if (!grid || !empty) return;

  const escapeHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#039;"
  })[character]);

  const readWishlist = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || "[]");
      return Array.isArray(value) ? [...new Set(value.filter(Boolean))] : [];
    } catch {
      return [];
    }
  };

  const formatMoney = (cents) => {
    const amount = (Number(cents || 0) / 100).toFixed(2);
    const format = grid.dataset.moneyFormat || "${{amount}}";
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(amount))))
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/<[^>]*>/g, "");
  };

  const render = async () => {
    const handles = readWishlist();
    empty.hidden = handles.length > 0;
    grid.hidden = handles.length === 0;
    if (!handles.length) {
      grid.innerHTML = "";
      return;
    }

    grid.setAttribute("aria-busy", "true");
    const products = (await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`/products/${encodeURIComponent(handle)}.js`);
        return response.ok ? await response.json() : null;
      } catch {
        return null;
      }
    }))).filter(Boolean);

    grid.innerHTML = products.map((product) => {
      const image = product.featured_image || product.images?.[0] || "";
      return `
        <article class="hn-wishlist-card">
          <a class="hn-wishlist-card__image" href="${escapeHtml(product.url)}">
            ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}" loading="lazy">` : ""}
          </a>
          <h2><a href="${escapeHtml(product.url)}">${escapeHtml(product.title)}</a></h2>
          <p>${escapeHtml(formatMoney(product.price))}</p>
          <button class="hn-product-wishlist" type="button" data-happyneon-wishlist-toggle="${escapeHtml(product.handle)}" aria-label="Remove ${escapeHtml(product.title)} from wishlist" aria-pressed="true">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21.3l7.8-7.8 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg>
          </button>
        </article>`;
    }).join("");
    grid.removeAttribute("aria-busy");
    empty.hidden = products.length > 0;
    grid.hidden = products.length === 0;
  };

  render();
  document.addEventListener("happyneon:wishlist-change", render);
  window.addEventListener("storage", render);
})();
